import React, { FC, useLayoutEffect, useRef } from 'react';
import Desktop from './desktop.svg';
import Mobile from './mobile.svg';
import s from './ModeToggle.scss';

type Mode = 'desktop' | 'mobile';
type ModeToggleProps = {
  value: Mode;
  onChange: (newMode: Mode) => void;
};

export const ModeToggle: FC<ModeToggleProps> = ({ value, onChange }) => {
  const ref = useRef<HTMLDivElement>();

  // this motherlover does not update dom (react is trash)
  useLayoutEffect(() => {
    if (ref.current) {
      const inputs = ref.current.querySelectorAll('input');
      inputs.forEach((input) => {
        input.removeAttribute('checked');
        if (value === input.value) {
          input.setAttribute('checked', '');
        }
      });
    }
  }, [value]);

  return (
    <div className={s.toggle} ref={ref}>
      <input
        type="radio"
        name="mode"
        id="view-modal-desktop"
        value="desktop"
        checked={value === 'desktop'}
        onChange={() => onChange('desktop')}
      />
      <label htmlFor="view-modal-desktop">
        <Desktop />
      </label>
      <div />
      <input
        type="radio"
        name="mode"
        id="view-modal-mobile"
        value="mobile"
        checked={value === 'mobile'}
        onChange={() => onChange('mobile')}
      />
      <label htmlFor="view-modal-mobile">
        <Mobile />
      </label>
    </div>
  );
};
